module.exports = __webpack_public_path__ + "img/1202.f1a2764a.png";